import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, HStack, Modal, Text, ModalOverlay, ModalContent, ModalHeader, ModalBody } from '@chakra-ui/react';
import { ArrowLeft, Icon } from '@whitbread-eos/atoms';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ImageGalleryModal = _ref => {
  var isModalOpen = _ref.isModalOpen,
    onModalClose = _ref.onModalClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var modalBody = _jsx(Box, {});
  return _jsxs(Modal, {
    isOpen: isModalOpen,
    onClose: onModalClose,
    size: "full",
    closeOnEsc: true,
    closeOnOverlayClick: false,
    scrollBehavior: "inside",
    blockScrollOnMount: true,
    "data-testid": "ImageGalleryModal",
    children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, {
      "data-testid": "ImageGalleryModal-Content",
      children: [_jsx(ModalHeader, {
        flexShrink: 0,
        p: 0,
        "data-testid": "ImageGalleryModal-Header",
        children: _jsx(Box, {
          bg: "lightGrey5",
          py: "xlg",
          px: {
            base: 'xlg',
            md: 'lg',
            lg: '5xl'
          },
          children: _jsxs(HStack, {
            gap: "sm",
            alignItems: "center",
            onClick: onModalClose,
            cursor: "pointer",
            children: [_jsx(Icon, _objectSpread({
              svg: _jsx(ArrowLeft, {})
            }, headerIconProps)), _jsx(Text, _objectSpread(_objectSpread({}, headerTextProps), {}, {
              children: t('hdp.imageGallery.modal.back')
            }))]
          })
        })
      }), _jsx(ModalBody, {
        flex: 1,
        "data-testid": "ImageGalleryModal-Body",
        children: modalBody
      })]
    })]
  });
};
var headerIconProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  w: 'var(--chakra-sizes-6)',
  h: 'var(--chakra-sizes-6)'
};
var headerTextProps = {
  fontWeight: 400,
  fontSize: {
    base: 'sm',
    sm: 'md'
  },
  lineHeight: {
    base: '2',
    sm: '3'
  }
};
export default ImageGalleryModal;